import { render, staticRenderFns } from "./LocumSuccessApplicationSent.vue?vue&type=template&id=09698130&"
import script from "./LocumSuccessApplicationSent.vue?vue&type=script&lang=js&"
export * from "./LocumSuccessApplicationSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports